import InputFilter from './inputFilter'

export default InputFilter